import React from "react";
import Container from "Components/Container/Container";

const Landing = ({ data }) => {
  return (
    <section className="my-secondary min-h-[50vh]">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-10">
          {data?.map((i, index) => (
            <div
              key={index}
              className="border flex items-center justify-center p-2 rounded-xl border-black"
            >
              <img className="object-contain" src={i} alt="" />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Landing;
